import { H6 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const TrendingSearch = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const CategoryLabel = styled(H6)`
  font-weight: ${themeStyle.fontBold};
  text-wrap: nowrap;
  letter-spacing: 0.01em;
  text-transform: capitalize;
`;

export const WrapperContent = styled.div`
  padding: 20px 120px;

  ${QUERIES.laptopAndUp} {
    padding: 20px 240px;
  }

  ${QUERIES.smallDesktopAndUp} {
    padding: 20px 400px;
  }
`;

export const SearchWrapper = styled(FlexColumn)`
  gap: 20px;
  margin: auto;
  max-width: 640px;
`;
